import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  key: 'showcasedata',
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    sessionId: 0,
    visitedPage: {}
  },
  getters: {
    sessionId: state => state.sessionId,
    visitedPage: state => state.visitedPage
  },
  mutations: {
    setSessionId (state, data) {
      Vue.set(state, 'sessionId', data)
    },
    setVisited (state, data) {
      if (data) {
        Vue.set(this.state.visitedPage, data, true)
      }
      // did not clear data in state
      // } else {
      //   Vue.set(state, 'visitedPage', {})
      // }
    }
  },
  actions: {
    setSessionIdIfNotExist ({ commit, state }, data) {
      if (state.sessionId === 0) {
        commit('setSessionId', `${Date.now()}`)
      }
    },
    setVisitedPage ({ commit, state }, service) {
      commit('setVisited', service || null)
    },
    trackCustomEvent (context, { event = null, action, target, linkTo = null, label = 'demo', value = null, amount = null }) {
      // window.onePalette.emitEvent(event || action, {
      //   action: action,
      //   target: target,
      //   linkTo: linkTo,
      //   label: label,
      //   value: value,
      //   amount: amount
      // })
    }
  },
  modules: {},
  plugins: [vuexLocal.plugin]
})
